import { createSelector } from '@ngrx/store';
import { authStateFeatureSelector } from '../state';

const selectState = createSelector(
  authStateFeatureSelector,
  (authState) => authState.loginSettings,
);

const selectLoginSettings = createSelector(
  selectState,
  (loginSettingsFeatureState) => loginSettingsFeatureState.loginSettings,
);

export const LoginSettingsSelectors = {
  selectLoginSettings,
};
